/* istanbul ignore file */
import React, { useContext, useMemo } from 'react';
import { AuthenticationToken } from 'infrastructure/security/authentication/DefaultTokenProvider';
import { getStoredAuthenticationToken } from 'infrastructure/security/authentication/tokenprovider/authenticationTokenRepository';

interface AuthenticationContext {
  getUserAlias: () => Nullable<string>;
  isAuthenticated: boolean;
  getToken: () => AuthenticationToken;
}

interface AuthenticationProviderProps {
  userAlias: Nullable<string>;
  isAuthenticated: boolean;
  getToken: () => AuthenticationToken;
  children: React.ReactNode;
}

const AuthenticationReactContext = React.createContext<AuthenticationContext>({
  getUserAlias: () => null,
  isAuthenticated: false,
  getToken: () => getStoredAuthenticationToken()?.token || null,
});

export const useAuthenticationProvider = () => useContext(AuthenticationReactContext);

export const AuthenticationProvider = ({
  getToken,
  isAuthenticated,
  userAlias,
  children,
}: AuthenticationProviderProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getUserAlias = () => userAlias;

  const contextValue = useMemo(
    () => ({
      getToken,
      isAuthenticated,
      getUserAlias,
    }),
    [getToken, getUserAlias, isAuthenticated],
  );

  return <AuthenticationReactContext.Provider value={contextValue}>{children}</AuthenticationReactContext.Provider>;
};
